module.exports = __webpack_public_path__ + "static/media/main.4ecb4b00.png";